module.exports = __webpack_public_path__ + "files/4c50c3d04b658d888dd8592210892deb.png";